<template>
  <header
    class="relative overflow-hidden from-primary to-pink-500 pt-20 md:pt-0 px-4"
  >
    <div class="container mx-auto py-16 md:py-24 relative z-10">
      <div class="flex flex-col md:flex-row items-center">
        <div class="md:w-1/2 md:pr-12 mb-10 md:mb-0">
          <div class="text-title font-bold text-[#333333] leading-tight mb-6">
            THE STANDARD FOR EXCELLENCE <br />
            THE FOUNDATION IN CRAFT<br />
          </div>
          <div class="text-desc">
            We offer various kinds of metal products such as keychains, badges,
            emblems, medals, coins, lapel pins, bottle opener, medallions, name
            tags, belt buckle, fridge magnet, souvenirs, and much more.
          </div>
        </div>
        <div class="md:w-1/2">
          <div class="relative">
            <img src="@/assets/banner-image.png" alt="WordPress Themes" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
// import Isvg from './ISvg'
export default {
  name: 'Template',
  components: {
    // Isvg
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/headerSection.vue